export enum CountryCode {
  Australia = 'au',
  NewZealand = 'nz',
  Thailand = 'th',
  Indonesia = 'id',
  HongKong = 'hk',
  Other = 'other',
}
